import React from "react";
import Context from "../../../../../context";

import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import "../index.scss";
import { useTranslation } from "react-i18next";

const ManagerInformation = () => {
  const { showModal, setShowModal, selectedCompany } = React.useContext(
    Context.CompanyScreen
  );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"30vw"}
        maxWidth={"40vw"}
        open={showModal === "SHOW_SUPERAGENT_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedCompany?.companyInformation?.superAgent?.avatar}
            name={
              selectedCompany?.companyInformation?.superAgent?.firstName
                ? selectedCompany?.companyInformation?.superAgent?.firstName
                : ""
            }
            lastName={
              selectedCompany?.companyInformation?.superAgent?.lastName
                ? selectedCompany?.companyInformation?.superAgent?.lastName
                : ""
            }
            phoneNumber={
              selectedCompany?.companyInformation?.superAgent?.phoneNumber
                ? selectedCompany?.companyInformation?.superAgent?.phoneNumber
                : ""
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedCompany?.companyInformation?.superAgent
              ?.superAgentSchoolInformation?.address && (
              <CustomView.Column
                medium={5}
                small={12}
                large={8}
                className="form-values form-column"
              >
                <label className="form-label">{t("address")} :</label>
                <p>
                  {
                    selectedCompany?.companyInformation?.superAgent
                      ?.superAgentSchoolInformation?.address
                  }
                </p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default ManagerInformation;
